module.exports = __webpack_public_path__ + "static/img/21.119cb57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/21.jpg
// module id = 9CxZ
// module chunks = 1